// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const BroadcastTypes = {
   newSearch:      "newSearchBroadcast",
   search:         "searchBroadcast",
   moreFacets:     "moreFacetsBroadcast",
   contentTypes:   "contentTypesBroadcast",
   disciplines:    "disciplinesBroadcast",
   languages:      "languagesBroadcast",
   library:        "libraryBroadcast",
   databases:      "databasesBroadcast",
   citationTrail:  "citationsBroadcast",
   other:          "otherBroadcast"
}

const BooleanValues = ["AND", "OR", "NOT"]

const QueryModifiers = ["AllWords", "AnyWords", "ExactMatch"]

const IdentifierQueryModifiers = ["ExactMatch", "BeginsWith"]

const MinLengthForBeginsWithQueries = 3

const IdentifierFields = [
   "CallNumAll",
   "IsbnAll",
   "IssnAll",
   "CODEN",
   "DEWEY",
   "DOI",
   "OCLC",
   "PatentNumber",
   "EAN",
   "EBSCOAN",
   "ERIC",
   "ISMN",
   "LCCN",
   "NAICS",
   "ORCID",
   "PCID",
   "PMID",
   "PQID",
   "PQPubID",
   "SSID",
   "UPC",
   "DUNS",
   "SICI"
]

const HelpLinks =
  {
     savedSearch: "https://knowledge.exlibrisgroup.com/Summon/Product_Documentation/Searching_in_The_Summon_Service/Using_Results/Summon%3A_Saving_Searches",
     savedItems:"https://knowledge.exlibrisgroup.com/Summon/Product_Documentation/Searching_in_The_Summon_Service/Using_Results/Summon%3A_Saving_Items_(Citations)"
  }

const FilterTextMappings = {
   topic: {
      'wikipedia': 'Wikipedia, the free encyclopedia'
   },
   sortOrder: {
      'PublicationDate|asc': 'date (oldest)',
      'PublicationDate|desc': 'date (newest)',
      'PublicationDate:asc': 'date (oldest)',
      'PublicationDate:desc': 'date (newest)',
      'Author|asc': 'Author',
      'Title|asc': 'Title'
   },
   readableOrder: {
      'PublicationDate|asc': 'oldest date',
      'PublicationDate|desc': 'newest date',
      'PublicationDate:asc': 'oldest date',
      'PublicationDate:desc': 'newest date',
      'Author|asc': 'Author',
      'Title|asc': 'Title'
   }
}

const Formats = {
   'music_recording'       : 'music',
   'film'                  : 'microfilm',
   'art'                   : 'artwork',
   'album'                 : 'music_cd',
   'compact_disc'          : 'music_cd',
   'conference_proceeding' : 'conference',
   'dvd'                   : 'video_dvd',
   'interactive_media'     : 'artifact',
   'research_guide'        : 'library_guide',
   'government_document'   : 'government',
   'dissertation'          : 'dissertation_thesis'
}

const CitationTrailTypes = {
   CITES: 1,
   CITED_BY: 2
}

const SearchTabs = {
   search: 1,
   citationTrail: 2
}

const RelatedItemTypes = {
   REVIEWS: 'reviews',
   CHAPTERS: 'chapters'
}

const AuthenticationEvents = {
   LOGINSUCCESS: 'auth-login-success',
   LOGININPROGRESS: 'auth-login-in-progress',
   LOGINAFTERREDIRECT: 'auth-login-after-redirect',
   LOGINAFTERPOPUP: 'auth-login-after-popup',
   LOGINEXPIRED: 'auth-login-expired',
   LOGINCANCELED: 'auth-login-canceled',
   LOGOUTSUCCESS: 'auth-logout-success',
   LOGOUTAFTERPOPUP: 'auth-logout-after-popup',
   LOGOUTAFTEREXPIRED: 'auth-logout-after-expired',
   LOGOUTAFTERREDIRECT: 'auth-logout-after-redirect',
   LOGOUTINPROGRESS: 'auth-logout-in-progress',
   SILENTLOGOUTINPROGRESS: 'auth-logout-in-progress-silent',
   NOTAUTHENTICATED: 'auth-not-authenticated',
   SIERRA_LOGIN_FAILED: 'sierra-login-failed',
   UNKNOWN: 'auth-unknown'
}

const FacetTypes = {
   REFINE_PANE: 'refinePane',
   CONTENT_TYPE: 'contentType',
   LANGUAGE: 'language',
   DISCIPLINE: 'discipline',
   LIBRARY: 'library',
   NEW_RECORDS: 'newRecords',
   DATABASE_NAME: 'databaseName'
}


angular.module('summonApp.constants')
   .constant('$broadcastTypes', BroadcastTypes)
   .constant('$booleanValues', BooleanValues)
   .constant('$queryModifiers', QueryModifiers)
   .constant('$identifierQueryModifiers', IdentifierQueryModifiers)
   .constant('$identifierFields', IdentifierFields)
   .constant('$minLengthForBeginsWithQueries', MinLengthForBeginsWithQueries)
   .constant('$helpLinks', HelpLinks)
   .constant('$filterTextMappings', FilterTextMappings)
   .constant('$formats', Formats)
   .constant('$citationTrailTypes', CitationTrailTypes)
   .constant('$relatedItemTypes', RelatedItemTypes)
   .constant('$searchTabs', SearchTabs)
   .constant('$authEvents', AuthenticationEvents)
   .constant('$facetTypes', FacetTypes)
